import { Answer, PollResponseVo } from '@schemas/non-auth'

export interface PollResultSetProps {
	poll: PollResponseVo
	selected: string[]
}

const VOTE_UNIT = ['명', '명', '명', '천명', '만명', '십만명', '백만명', '천만명', '억명', '십억명']

export const computeAnswerList = (list: Array<Answer>) => {
	return list
		.map((answer) => {
			return {
				...answer,
				answerPollCnt: Number(answer?.answerPollCnt),
			}
		})
		.sort((a, b) => {
			return b.answerPollCnt - a.answerPollCnt
		})
}

export const getTotal = (list: Array<Answer>): number =>
	list.reduce((sum, answer) => sum + Number(answer?.answerPollCnt ?? 0), 0)
// eslint-disable-next-line @typescript-eslint/default-param-last
export const getPercent = (count = 0, total: number) =>
	count === 0 && total === 0 ? 0 : Math.round((count / total) * 1000) / 10

export const remainPercent = (list: Array<Answer>, total: number) => {
	return (
		(1000 -
			[...list].slice(0, -1).reduce((sum, { answerPollCnt }) => {
				return sum + getPercent(answerPollCnt as number, total) * 10
			}, 0)) /
		10
	)
}

export const getVote = (count = 0) => {
	const digit = count.toString().length
	const value = digit > 3 ? count / 10 ** (digit - 1) : count
	return `${Math.floor(value * 10) / 10}${VOTE_UNIT[digit - 1]}`
}
